import React, {useEffect, useState, useRef} from 'react'
import classnames from 'classnames'
import {Link, Redirect} from 'react-router-dom'

function Navigation() {
  const [scrollPos, setScrollPos] = useState(window.pageYOffset)
  const [visible, setVisible] = useState(true)
  const _scrollPos = useRef(scrollPos)
  const _setScrollPos = (data) => {
    _scrollPos.current = data
    setScrollPos(data)
  }
  const handleScroll = () => {
    const currentPos = window.pageYOffset
    setVisible(_scrollPos.current > currentPos)
    _setScrollPos(currentPos)
  }
  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])
  return (
    <React.Fragment>
      <nav
        className={classnames(
          'navbar overflow-scroll navbar-dark navbar-expand-lg fixed-top',
          {
            'navbar--hidden': !visible,
          }
        )}
      >
        <button
          className="navbar-toggler"
          data-target="#my-nav"
          data-toggle="collapse"
          aria-controls="my-nav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <a className="navbar-brand mr-auto ml-auto">COVID19GLOBAL</a>
        <div id="my-nav" className="collapse navbar-collapse">
          <ul className="navbar-nav  ml-auto">
            <li className="nav-item">
              <Link className="nav-link " to="/">
                <div className="nav-links-text">Home</div>
              </Link>
            </li>
            <li className="nav-item ">
              <Link className="nav-link " to="/analysis">
                <div className="nav-links-text">Analysis</div>
              </Link>
            </li>
            <li className="nav-item ">
              <Link className="nav-link " to="/help">
                <div className="nav-links-text">Help?</div>
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </React.Fragment>
  )
}

export default Navigation
